export const HOME_PAGE_VISIT = 'school_home_page_visit'

export const LIVE_LIST_VISIT = 'school_live_list_visit'

export const LIVE_DETAIL_VISIT = 'school_live_detail_visit'

export const RECORD_LIST_VISIT = 'school_record_list_visit'

export const RECORD_DETAIL_VISIT = 'school_record_detail_visit'

export const RECORD_VIDEO_CHOOSE = 'school_record_detail_video_choose'

export const PROFILE_CLICK = 'school_profile_click'

export const SCHOOL_PAGE_CLICK = 'school_page_click'
// 课程搜索页
export const SCHOOL_CLASS_SEARCH_VISIT = 'school_class_search_visit'
export const SCHOOL_CLASS_SEARCH_CLICK = 'school_class_search_click'
